export default __webpack_public_path__ + "static/media/blog-driveway-pattern-006.770aed6e.jpg";